<template>
  <q-card
    :class="{'text-secondary': active}"
    @click="$emit('click')"
  >
    <q-card-section>
      <div class="text-h6 row items-center">
        <div class="col">
          {{ site.name }}
        </div>
        <div class="col-auto">
          <lwf-badge-bool
            v-if="site.status !== 100"
            :value="site.status === 100"
            :labels="['Désactivé', 'Activé']"
          />
        </div>
      </div>
      <div>
        <span>Client: {{ site.customer.name }}</span>
      </div>
      <basic-address :address="site.address || site" />
      <div
        v-if="specialties && site.specialties"
        class="q-gutter-xs"
      >
        <q-badge
          v-for="spec in site.specialties"
          :key="spec.specialty.slug"
          color="orange"
          :label="spec.specialty.name"
        />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import BasicAddress from 'components/Basic/BasicAddress'
import LwfBadgeBool from 'components/core/LwfBadgeBool'

/**
 * Card d'affichage d'un site
 */
export default {
  name: 'CardSite',
  components: { LwfBadgeBool, BasicAddress },
  props: {
    /**
     * Affiche ou non les specialités
     */
    specialties: Boolean,
    /**
     * Le site à afficher
     */
    site: {
      type: Object,
      required: true
    },
    /**
     * La card à t'elle le focus ?
     */
    active: Boolean
  }
}
</script>
